module.exports = __webpack_public_path__ + "img/Speaker=Bryan Pham.3489703d.png";